<template>
  <div class="p-6 pb-0">
    <BreadCrumbs :navigation="navigation" />
  </div>
  <!-- Corpo -->
  <div class="p-6 flex flex-col lg:flex-row items-start gap-6">
    <WelcomeUser :user="user" />
    <ModuleList :modules="links" />
  </div>
</template>

<script>
import { Link, usePage } from '@inertiajs/vue3';
import WelcomeUser from '@/Components/WelcomeUser.vue';
import ModuleList from '@/Components/ModuleList.vue';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Layout from '@/Layouts/Layout.vue';

export default {
  components: {
    Link,
    WelcomeUser,
    ModuleList,
    BreadCrumbs,
    Layout
  },
  computed: {
    links() {
      let entries = [];

      this.submodules.forEach(submodule => {
        entries.push({
          id: submodule.id,
          name: this.$t(submodule.name),
          slug: submodule.slug,
          icon: submodule.icon,
          href: route(submodule.route),
          active: submodule.active
        });
      });

      return entries;
    },
    navigation() {
      return [
        {
          name: 'Dashboard',
          href: route('dashboard'),
        },
        {
          name: this.$t('modules.' + this.moduleSlug),
          href: route('modules.home', this.moduleSlug),
        }
      ];
    }
  },
  props: ['user', 'modules', 'submodules', 'moduleSlug']
};
</script>